<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e6Iq0d/tc-custom/9781460324035.jpg?1718182734986" alt="This image is the cover for the book Beneath the Stetson, Texas Cattleman's Club: The Missing Mogul"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beneath the Stetson, Texas Cattleman's Club: The Missing Mogul
      </h1>
      <p class="bookDescription body article font2">
        <p>In this Texas Cattleman's Club tale, USA TODAY bestselling author Janice Maynard brings you the sexiest single dad in Royal, Texas! <br/><br/>Millionaire rancher Gil Addison does <i>not</i> need Bailey Collins. She is far from the sweet homemaker he thought he wanted. But she <i>is</i> a beautiful woman with a badge, hot on the heels of a kidnapper in Gil's club. And Gil is hot for her! <br/><br/>Bailey can't let her career get sidetracked by the cowboy and his son. She's here to do a job, not find a family. Bailey won't stop till she gets her man in cuffs. Trouble is, Gil won't stop till he gets this woman in his bed!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Janice Maynard
      </h2>
      
      <p class="authorDescription body article"><I>USA TODAY</I> bestselling author Janice Maynard loved books and writing even as a child. Now, creating sexy, character-driven romances is her day job! She has written more than 75 books and novellas which have sold, collectively,&#160;almost three million copies. Janice lives in the shadow of the Great Smoky Mountains with her husband, Charles. They love hiking, traveling, and spending time     with family. <Br><Br>Connect with Janice at www.JaniceMaynard.com and on all&#160;socials.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?15d90d40